class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg viewBox="0 0 17 18" fill-opacity="0" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 9C16.5 13.4183 12.9183 17 8.5 17C4.08172 17 0.5 13.4183 0.5 9C0.5 4.58172 4.08172 1 8.5 1" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  }
}
const e = "pwc-icon-loading";
customElements.get(e) || customElements.define(e, t);
